import { put, select } from "redux-saga/effects";
import importer from "common/importer";
const LoyalDonorActions = importer("Stores/Loyalty/Actions");
const { redeemRewards } = importer("APIs/loyalty", null);
const { tokens } = importer("Stores/Users/Select", null);
export default function* main({data}) {

  try {
    const _tokens = yield select(tokens);
    const { token_type, id_token } = _tokens;
    const token = `${token_type} ${id_token}`;
    yield put(LoyalDonorActions.redeemRewardsLoading());
    const res = yield redeemRewards(data, token);
    yield put(LoyalDonorActions.redeemRewardsSuccess(res));
  } catch (error) {
    yield put(LoyalDonorActions.redeemRewardsFailure(error));
  }
}